import { api } from 'API/axios';
import { HTTP_STATUS_CODES } from 'Enum/HttpStatusCodes';
import { IPersonalDetailsReqAttach } from 'Interfaces/updatePersonalDetails';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/newRequest';

export interface IRequestsData {
  fieldAttachmentsData: IRequestsFieldData[];
  note: string;
  phoneNumber: string;
  phonePrefix: string;
  type: number;
  id?: number;
  requestDataJson?: any;
  internetReqNum?: number;
}

export interface IRequestsFieldData {
  fieldId: string;
  attachments: { [fileName: string]: File };
}

export interface IUploadFileList {
  isRequired: boolean;
  requiredWith?: number[];
  requiredFieldGroupId?: number;
  name: string;
  id: string;
  downloadFormUrl?: string;
}
export interface IFormMetaData {
  formName: string;
  attachments: IUploadFileList[];
}

export const createRequest = async (body: any) => {
  try {
    const newRequest = await api.post(addImposterToUrl(baseUrl, true), body, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return newRequest;
  } catch (error: any) {
    if (
      error.response?.status === HTTP_STATUS_CODES.InternalServerError &&
      error.response?.data?.tryAgain
    ) {
      return {
        data: {
          tryAgain: true,
          failedFiles: error.response.data.failedFiles,
        },
      };
    }
  }
};

export const getRequestFields = async (
  reqSubTypeId: number,
  reqAttachSchema?: IPersonalDetailsReqAttach,
) => {
  const query = reqSubTypeId
    ? `?reqSubTypeId=${reqSubTypeId}${
        reqAttachSchema
          ? `&addresses=${reqAttachSchema.addresses}&familyMembers=${
              reqAttachSchema.familyMembers
            }${
              reqAttachSchema.maritalStatus
                ? `&maritalStatus=${reqAttachSchema.maritalStatus}`
                : ''
            }`
          : ''
      }`
    : '';

  const res = await api.get<IFormMetaData>(
    addImposterToUrl(baseUrl + '/formMetaData' + query, false),
  );

  if (res?.data) {
    return res.data;
  } else if (res?.status === HTTP_STATUS_CODES.Forbidden)
    return {
      formName: '',
      attachments: [],
    };
};
